import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import App from './App.vue';
import router from './router';
import store from './store/index';
import vuetify from './plugins/vuetify';
import axios from 'axios';
import config from './config';
import * as VueGoogleMaps from 'vue2-google-maps'
import {AuthMixin} from './mixins/auth';
import {RoleMixin} from './mixins/role';

// สไตล์ CSS สำหรับ SweetAlert2
import 'sweetalert2/dist/sweetalert2.min.css';

axios.defaults.baseURL = config.baseURLApi;
axios.defaults.headers.common['Content-Type'] = 'application/json';

const token = localStorage.getItem('token');
const equipmentUserToken = localStorage.getItem('equipment_token');


if (token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
} else if (equipmentUserToken) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + equipmentUserToken;
}

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyB7OXmzfQYua_1LEhRdqsoYzyJOPh9hGLg',
    },
});

Vue.use(VueSweetalert2);

Vue.mixin(AuthMixin);
Vue.mixin(RoleMixin);
Vue.config.productionTip = false;


// console.log('token :'+token);
// console.log('equipmentUserToken :'+equipmentUserToken);


if (token) {
    store.dispatch('auth/doInit');
} else if (equipmentUserToken) {
    store.dispatch('auth/doInit');
}


new Vue({
    vuetify,
    router,
    render: (h) => h(App),
    store,
}).$mount('#app');
